// extracted by mini-css-extract-plugin
export default {"maxheight":"info-tile_maxheight__iZ3f9"};